<template>
    <div style="padding: 200px 0;">
        <b-container>
            <b-card no-body style="border: 0; background-color: #fff;" class="p-4">
                <h3 class="text-center my-3 pb-2">重設密碼</h3>
                <p class="text-muted text-center mb-4">密碼至少需 12 碼，並包含大小寫英文字母、數字與特殊字元。</p>

                <b-alert v-if="error" variant="danger" show class="mb-3">{{ error }}</b-alert>
                <b-alert v-if="success" variant="success" show class="mb-3">
                    密碼變更成功，請重新登入。
                </b-alert>

                <b-form-group class="course-search">
                    <b-input-group>
                        <template #prepend>
                            <b-input-group-text>
                                <b-icon-lock></b-icon-lock>
                            </b-input-group-text>
                        </template>
                        <b-form-input
                            id="reset-password"
                            :type="showPassword ? 'text' : 'password'"
                            placeholder="新密碼"
                            v-model.trim="password"
                            @keypress="onKeypress"
                        ></b-form-input>
                        <b-input-group-append>
                            <b-button variant="outline-secondary" @click="showPassword = !showPassword">
                                <b-icon :icon="showPassword ? 'eye-slash' : 'eye'"></b-icon>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                    <PasswordRequirements :password="password" />
                </b-form-group>

                <b-form-group class="course-search">
                    <b-input-group>
                        <template #prepend>
                            <b-input-group-text>
                                <b-icon-lock></b-icon-lock>
                            </b-input-group-text>
                        </template>
                        <b-form-input
                            id="reset-password-confirm"
                            :type="showPasswordConfirm ? 'text' : 'password'"
                            placeholder="確認新密碼"
                            v-model.trim="passwordConfirm"
                            @keypress="onKeypress"
                        ></b-form-input>
                        <b-input-group-append>
                            <b-button variant="outline-secondary" @click="showPasswordConfirm = !showPasswordConfirm">
                                <b-icon :icon="showPasswordConfirm ? 'eye-slash' : 'eye'"></b-icon>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>

                <div class="text-muted small mb-3">
                    建議使用至少 12 碼，並混合大小寫、數字與符號，例如 `Abcd1234!xyz`。
                </div>

                <b-button pill class="mb-3" variant="primary" block :disabled="loading || !token" @click="submit">
                    <span v-if="loading" class="spinner-border spinner-border-sm mr-2"></span>
                    變更密碼
                </b-button>
            </b-card>
        </b-container>
    </div>
</template>

<script>
import { apiResetPasswordByToken } from '@/api/API';
import PasswordRequirements from '@/components/PasswordRequirements.vue';

export default {
    name: 'Forget',
    components: {
        PasswordRequirements,
    },
    data() {
        return {
            token: '',
            password: '',
            passwordConfirm: '',
            loading: false,
            error: '',
            success: false,
            showPassword: false,
            showPasswordConfirm: false,
        };
    },
    created() {
        this.token = this.$route.query.code || '';
        this.clearTokenFromUrl();

        if (!this.token) {
            this.error = '缺少重設密碼驗證碼';
        }
    },
    mounted() {
        const navBgSwitch = this._storeData('navBgSwitch');
        if (this.IsNull(navBgSwitch) !== '') {
            navBgSwitch(false);
        }
    },
    methods: {
        clearTokenFromUrl() {
            if (!this.$route.query.code) {
                return;
            }

            this.$router.replace({
                name: this.$route.name,
                query: {},
            }).catch(() => {});
        },
        onKeypress(event) {
            if (event.charCode === 13) {
                this.submit();
            }
        },
        validatePassword() {
            if (!this.password) {
                return '未填寫新密碼';
            }
            if (!this.passwordConfirm) {
                return '未填寫確認新密碼';
            }
            if (this.password !== this.passwordConfirm) {
                return '新密碼與確認新密碼不符';
            }
            if (this.password.length < 12) {
                return '密碼長度至少需 12 碼';
            }
            if (!/[A-Z]/.test(this.password)) {
                return '密碼至少需包含一個大寫英文字母';
            }
            if (!/[a-z]/.test(this.password)) {
                return '密碼至少需包含一個小寫英文字母';
            }
            if (!/[0-9]/.test(this.password)) {
                return '密碼至少需包含一個數字';
            }
            if (!/[^A-Za-z0-9]/.test(this.password)) {
                return '密碼至少需包含一個特殊字元';
            }

            return '';
        },
        async submit() {
            this.error = '';
            const validationError = this.validatePassword();
            if (validationError) {
                this.error = validationError;
                return;
            }

            this.loading = true;
            this.success = false;

            try {
                await apiResetPasswordByToken({
                    token: this.token,
                    password: this.password,
                    passwordConfirm: this.passwordConfirm,
                });
                this.success = true;
                this.password = '';
                this.passwordConfirm = '';
                setTimeout(() => {
                    this.$router.push('/');
                }, 1500);
            } catch (error) {
                const responseMessage =
                    error?.response?.data?.message ||
                    error?.response?.data?.error ||
                    error?.response?.data;
                this.error = responseMessage || '密碼變更失敗';
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
